import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers";

import { t } from "@/i18n-js/instance";
import { useDevelopersAccessFlags } from "@/react/hooks/developers/useDevelopersAccessFlags";

import { NavGroup } from "../NavGroup";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

export const useDevelopersLinks = (): Link[] => {
  const { isAdminApiFeatureEnabled, isHeadlessApiFeatureEnabled } =
    useDevelopersAccessFlags();

  const isOverviewDisabled =
    !isAdminApiFeatureEnabled && !isHeadlessApiFeatureEnabled;

  const links: Link[] = [
    {
      label: t("settings_nav_v3.developers.overview"),
      path: settingsNavPathV3.developers.overview,
      exact: true,
      isDisabled: isOverviewDisabled,
    },
    {
      label: t("settings_nav_v3.developers.api"),
      path: settingsNavPathV3.developers.api,
      exact: false,
    },
  ];

  return links;
};

export const DevelopersLinks = () => {
  const links = useDevelopersLinks();

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content title={t("settings_nav_v3.developers.title")}>
        {links.map(link => (
          <SubNavLinkItem
            isDisabled={link.isDisabled}
            key={link.path}
            label={link.label}
            to={link.path}
          />
        ))}
      </NavGroup.Content>
    </NavGroup>
  );
};
